import React from 'react';
import { css } from '@emotion/css';
import { campaigns } from '../../common/campaigns';
import financingBannerImage from './financing-banner-img.png';
import { useIntl } from '@/i18n';
import { PromotionBanner } from '@/components/content/someBanner/PromotionBanner';

const styles = {
  image: css`
    height: 72px;
  `,
};

export const FinancingOfferBanner = () => {
  const { t } = useIntl();

  return (
    <PromotionBanner
      className='padding-vertical-xs palm-padding-vertical-l padding-left-xl'
      image={<img className={`${styles.image}`} src={financingBannerImage} alt={''} aria-hidden='true' />}
      content={t(
        {
          id: 'FinancingOfferBanner.description',
          defaultMessage: 'Was kannst du dir leisten? Prüfe kostenlos und unverbindlich deine passende Finanzierung.',
        },
        {
          Link: (
            <a href={campaigns.FINANCING_OFFER}>
              {t({ id: 'FinancingOfferBanner.linkText', defaultMessage: 'Jetzt starten' })}
            </a>
          ),
        },
      )}
    />
  );
};
